import type { IconName } from '@freelancer/ui/icon';

export enum SocialMediaText {
  facebook = 'Facebook',
  twitter = 'Twitter',
  linkedin = 'LinkedIn',
  reddit = 'Reddit',
  telegram = 'Telegram',
}

export interface SocialMediaInfo {
  iconName: IconName;
  className: string;
  text: string;
  labelText: string;
}

export const LIST_OF_SOCIAL_MEDIA_INFO: {
  [key in ShareIcons]: SocialMediaInfo;
} = {
  facebook: {
    iconName: 'ui-facebook-filled',
    className: '--facebook',
    text: 'Facebook',
    labelText: $localize`Share on Facebook`,
  },
  twitter: {
    iconName: 'ui-twitter',
    className: '--twitter',
    text: 'Twitter',
    labelText: $localize`Share on Twitter`,
  },
  linkedin: {
    iconName: 'ui-linkedin-filled',
    className: '--linkedin',
    text: 'LinkedIn',
    labelText: $localize`Share on LinkedIn`,
  },
  reddit: {
    iconName: 'ui-reddit',
    className: '--reddit',
    text: 'Reddit',
    labelText: $localize`Share on Reddit`,
  },
  telegram: {
    iconName: 'ui-telegram',
    className: '--telegram',
    text: 'Telegram',
    labelText: $localize`Share on Telegram`,
  },
};

export type ShareButtonSizes = 'mid' | 'large';

export type ShareIcons =
  | 'facebook'
  | 'twitter'
  | 'linkedin'
  | 'reddit'
  | 'telegram';

export type ShareButtonSpacing =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'initial'
  | 'inherit';
